package org.matthewo.collections

inline fun <T> List<T>.forEachReverse(action: (T) -> Unit) {
    for (i in indices.reversed()) {
        action(this[i])
    }
}

inline fun <T> List<T>.forEachReverseIndexed(action: (Int, T) -> Unit) {
    for (i in indices.reversed()) {
        action(i, this[i])
    }
}
